{
  "ClientConfigurationModal_AddTitle": "Add Client Configuration",
  "ClientConfigurationModal_ChangeTitle": "Change Client Configuration",
  "ClientConfigurationModal_Footer_Actions_Submit": "Submit",
  "ClientConfigurationModal_Footer_Actions_Cancel": "Cancel",
  "ClientConfigurationModal_Footer_Actions_Help": "Help",
  "ClientConfigurationModal_Tabs_Details": "Details",
  "ClientConfigurationModal_Tabs_Scope": "Scope",
  "ClientConfigurationModal_Tabs_Policy": "Policy",
  "ClientConfigurationModal_Tabs_Settings": "Settings",
  "ClientConfigurationModal_Tab_Details_Description": "Description",
  "ClientConfigurationModal_Tab_Details_Description_Required": "Description is required",
  "ClientConfigurationModal_Tab_Details_ID": "ID",
  "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Auto Assigned]",
  "ClientConfigurationModal_Tab_Details_Override": "Override all clients configuration",
  "ClientConfigurationModal_Tab_Scope_CME": "CME",
  "ClientConfigurationModal_Tab_Scope_Telsys": "Telephony Server",
  "ClientConfigurationModal_Tab_Scope_Telsys_Required": "Telephony Server is required",
  "ClientConfigurationModal_Tab_Scope_Partition": "Partition",
  "ClientConfigurationModal_Tab_Scope_Device": "Device",
  "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Filter Recursively",
  "ClientConfigurationModal_Tab_Policy_PolicyItem": "Policy Item",
  "ClientConfigurationModal_Tab_Policy_DefaultValue": "Default Value",
  "ClientConfigurationModal_Tab_Policy_ActualValue": "Actual Value",
  "ClientConfigurationModal_Error_NotFound": "Client configuration not found or does not exist",
  "ClientConfigurationModal_Policy_core::showUseConfigurationWindow": "Core - Can Show/Use Configuration Window",
  "ClientConfigurationModal_Policy_core::permittedToLogin": "Core - Permitted to Login",
  "ClientConfigurationModal_Policy_configOptions::useLocalhostAPI": "Config - use Localhost API",
  "ClientConfigurationModal_Policy_configOptions::canConfigureCustomEvents": "Config - Configure Custom Events",
  "ClientConfigurationModal_Policy_menuOptions::canShowAddressBook": "Menu - Address Book",
  "ClientConfigurationModal_Policy_crm::canAddNewContacts": "Can add New Contacts to CRMs (through wizard)",
  "ClientConfigurationModal_Tab_Settings_SettingsItem": "Setting Option",
  "ClientConfigurationModal_Tab_Settings_DefaultValue": "Default Value",
  "ClientConfigurationModal_Tab_Settings_ActualValue": "Actual Value",
  "ClientConfigurationModal_Settings_interface::showCallNotificationPreview": "Interface - Show Call Notification Preview",
  "ClientConfigurationModal_Settings_interface::showMissedCallPreview": "Interface - Show Missed Call Preview",
  "ClientConfigurationModal_Settings_interface::connectedHideDelay": "Interface - Connected Hide Delay",
  "ClientConfigurationModal_Settings_interface::previewWindowAlwaysOnTop": "Interface - Preview Window Always on Top",
  "ClientConfigurationModal_Settings_interface::showContactInEditMode": "Interface - Show Contact in Edit Mode",
  "ClientConfigurationModal_Settings_hotkey::makeCall": "Hotkey - Make Call",
  "ClientConfigurationModal_Settings_interface::applicationLoadAtWindowsStartup": "Interface - Application Load at Windows Start-up",
  "ClientConfigurationModal_Settings_dialing::clipboardDialing": "Dialing - Clipboard Dialing",
  "ClientConfigurationModal_Settings_dialing::focusDialing": "Dialing - Focus Dialing",
  "ClientConfigurationModal_Settings_dialing::screenDialing": "Dialing - Screen Dialing",
  "ClientConfigurationModal_Settings_logPage::sendAnonymousStats": "Log Page - Send Anonymous statistics",
  "ClientConfigurationModal_Settings_logPage::loggingLevel": "Log Page - Logging Level",
  "ClientConfigurationModal_Settings_version::checkForUpdates": "Version - Check for updates and Download",
  "NAME": "ClientConfigurationModalLanguage"
}